import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import * as React from 'react';
import Divider from '@material-ui/core/Divider';
import { Paper } from '@material-ui/core';
import Hidden from '@material-ui/core/Hidden';
import { useStyles } from './css';

export const FormSection: React.FC<{ title: string; description?: string }> = ({
    title,
    description,
    children,
}) => {
    const classes = useStyles();

    return (
        <React.Fragment>
            <Hidden smDown>
                <Divider className={classes.formDivider} />
            </Hidden>
            <Grid
                container
                justify="flex-start"
                alignItems="flex-start"
                className={classes.formSection}
            >
                <Grid item lg={4} md={12} sm={12} xs={12}>
                    <Box paddingRight={3}>
                        <Typography
                            variant="h6"
                            className={classes.formSectionHeading}
                            gutterBottom
                        >
                            {title}
                        </Typography>
                        <Typography
                            gutterBottom
                            component="p"
                            variant="body2"
                            paragraph={true}
                            color="textSecondary"
                        >
                            {description}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item lg={8} md={12} sm={12} xs={12}>
                    <Paper className={classes.formPaper} elevation={3}>
                        {children}
                    </Paper>
                </Grid>
            </Grid>
        </React.Fragment>
    );
};
